import { Collapsebox } from './collapsebox.js';

export class CollapseboxPopularlocations extends Collapsebox {
	
	constructor(component_key) {
		super(component_key);
		this.alphabetFilter = new AlphabetFilter(); // Instantiate the Filter
	}
	
	init() {
		this.$collapse_el = jQuery(`.js-${this.name}_collapse`);
		this.$collapse_body_el = jQuery(`.js-${this.name}_collapse_body`);
		this.$show_more_btn = jQuery(`.js-${this.name}_showmore_btn`);
		super.init();
		jQuery('.js-alphabet_filter_el').off('click').on('click', (e) => this.alphabetFilter.init_alphabet_filter(e));
		jQuery('.js-alphabet_filter_el').on('keydown', yalwa.basics.keyhandler_for_space_and_enter);
		jQuery(document).on('click', '.js-remove_chip', (e) => this.alphabetFilter.remove_chip_listener(e));
		jQuery('.js-pop_locations_showmore_btn').off('click').on('click',(e) =>  this.show_more_btn(e));
	}
	
	show_more_btn(e) {
		const $this = jQuery(e.currentTarget);
		const $show_more_body_el = $this.parent().find('.js-pop_locations_showmore_body');
		const $show_more_label = $this.find('.js-pop_locations_showmore_text');
		
		const label = $this.hasClass('js-active') ? $this.data('label_showmore') : $this.data('label_showless');
		$this.toggleClass('js-active');
		$show_more_body_el.slideToggle().toggleClass('js-active');
		$show_more_label.html(label);
		if ($this.hasClass('js-active')) {
			this.alphabetFilter.show_all();
		} else {
			this.alphabetFilter.close_all()
		}
	}

}
export class AlphabetFilter {
	constructor() {
		this.filtered_alphabets = [];
		this.filterd_body_el = '';
	}
	init_alphabet_filter(e) {
			let $this = jQuery(e.currentTarget);
			$this.addClass('js-active');
			let alphabet = $this.attr('data-filter_alphabet');
			let alphabet_to_show = $this.attr('data-alphabet');
			this.filterd_body_el = $this.parent().parent().find('.js-alphabet_filter_body > div');
			let $closest_filtered_chips = $this.parent().parent().find('.js-filtered_chips');
			if (!(alphabet in this.filtered_alphabets)) {
				this.filtered_alphabets[alphabet] = {alphabet: alphabet, alphabet_to_show: alphabet_to_show};
				yalwa.basics.hide(this.filterd_body_el);
				this.update_filtered_view($closest_filtered_chips);
			} else {
				//Already Filtered
				this.remove_chip_listener(e);
				jQuery(`.js-remove_chip[data-filter_alphabet="${alphabet}"]`).parent().remove();
			}
	}
	close_all() {
		//Reset all
		jQuery('.js-alphabet_filter_body > div:nth-child(-n+26) > .js-collapsebox_collapse.js-active').trigger('click');
	}
	show_first_two() {
		//Open first 2
		jQuery('.js-alphabet_filter_body > div:nth-child(-n+2) > .js-collapsebox_collapse').trigger('click');
	}
	show_all() {
		//Open all
		jQuery('.js-alphabet_filter_body > div > .js-collapsebox_collapse').trigger('click');
	}
	update_filtered_view($closest_filtered_chips) {
		$closest_filtered_chips.html('');
		if (Object.keys(this.filtered_alphabets).length <= 0) {
			//Reset all
			this.close_all()
			this.show_all();
			
			//Show all
			yalwa.basics.show(this.filterd_body_el);
			return;
		}
		
		Object.values(this.filtered_alphabets).forEach(obj => {
			yalwa.basics.show(jQuery('.js-collapsebox_other_locations_' + obj.alphabet));
			jQuery('.js-collapsebox_other_locations_' + obj.alphabet + ' > .js-collapsebox_collapse:not(.js-active)').trigger('click');
			$closest_filtered_chips.append(this.filter_chip_element(obj.alphabet, obj.alphabet_to_show));
		});

		
	}
	filter_chip_element(alphabet, text) {
		return `<div class="filtered_chips__item">
                <span>${text}</span>
                <span class="js-remove_chip" data-filter_alphabet="${alphabet}">
         			${yalwa.basics.yicon('close--blue', {folder: 'main', pixel: 8, classes: ''})}
                </span>
            </div>`;
	}
	remove_chip_listener(e) {
		let alphabet = jQuery(e.currentTarget).attr('data-filter_alphabet');
		this.filtered_alphabets = Object.fromEntries(
			Object.entries(this.filtered_alphabets).filter(([key, value]) => key !== alphabet)
		);
		
		// Hide elements related to the removed alphabet
		yalwa.basics.hide(jQuery('.js-collapsebox_other_locations_' + alphabet));
		//Remove Active Class
		jQuery(`.js-alphabet_filter_el[data-filter_alphabet="${alphabet}"]`).removeClass('js-active');
		// Update UI
		let $closest_filtered_chips = jQuery(e.currentTarget).closest('.js-filtered_chips');
		this.update_filtered_view($closest_filtered_chips);
	}
}
